"use client";

import React, { useEffect, useState } from "react";
import { LuChevronUp } from "react-icons/lu";

import { TestIdEnum } from "../../../tests/types";

export const MoveToTopButton = (): React.ReactElement => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      data-testid={TestIdEnum.MoveToTopButton}
      onClick={handleClick}
      className={`fixed bottom-4 right-4 z-50 p-3 rounded-full bg-brand-600 text-white shadow-lg transition-all duration-300 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      aria-label="Move to top"
    >
      <LuChevronUp className="w-6 h-6" />
    </button>
  );
};
